export enum QUICK_LINK_TYPE {
  PROVIDER = 'PROVIDER',
  PROCEDURE = 'PROCEDURE',
}
